import Script from 'next/script';

export default function KlarnaScript() {
  return (
    <Script
      strategy="afterInteractive"
      src={process.env.NEXT_PUBLIC_KLARNA_URL}
      data-client-id={process.env.NEXT_PUBLIC_KLARNA_CLIENT_ID}
    />
  );
}
